import "./style.scss";
import GenericForm from "../genericForm";
import Input from "../input";
import React, {useState} from "react";
import Textarea from "../textarea";
import {API_URL} from "../../../config";

const ApiTestHarness = (props) => {
  const {
    title,
    formClassName,
    responseBody,
    submitAction
  } = props;

  const [requestBody, setRequestBody] = useState(null);
  const [apiUrl, setApiUrl] = useState(API_URL);

  const onSubmitAction = () => {
    submitAction(apiUrl, JSON.parse(requestBody));
  }

  return (
    <GenericForm formTitle={title} formClassName={(formClassName) ? formClassName : 'api-test-harness-form'} submitLabel='Submit' disabled={false} submitAction={onSubmitAction}>
      <Input
        name='apiUrl'
        id='apiUrl'
        value={apiUrl}
        changeAction={setApiUrl}
        label='API Endpoint URL*'
        type='text'
        disabled={false}
      />
      <Textarea
        name='requestBody'
        id='requestBody'
        value={requestBody}
        changeAction={setRequestBody}
        label='Request Body (JSON)*'
        />
      {responseBody && <Textarea
        name='responseBody'
        id='responseBody'
        value={JSON.stringify(responseBody, undefined, 4)}
        label='Response (JSON)'
        disabled={true}
        hide={(responseBody)}
        />}
    </GenericForm>
  );
}

export default ApiTestHarness;